import React from 'react';
import {Flex, Title, Text, Link, Scrollbar} from '@priority-software/priority-style-react';
import styles from '.././styles.module.scss';
import {useEffect, useState} from 'react';
import Lottie from 'react-lottie';
import {isRTL} from '../../../Localization';

interface DialogContentProps {
    content: string;
    title: string;
    additionalContent: string;
    lottieContent: {[key: string]: any};
    linkText?: string;
    linkUrl?: string;
    showMoreLinkHandler: (linkUrl: string) => void;
}

interface ContentCompProps {
    content: string;
    linkText: string;
    linkUrl: string;
    showMoreLinkHandler: (linkUrl: string) => void;
}

const ContentComp = (props: ContentCompProps) => {
    const {content, linkText, linkUrl, showMoreLinkHandler} = props;
    if (!!linkText) {
        return (
            <>
                <Text
                    skin="paragraph-1"
                    fontWeight="normal"
                    textColor="primary-700"
                    componentClasses={styles.dialogContentText}
                >
                    {`${content} \n`}
                </Text>
                <Link
                    textSize="medium"
                    onClick={() => showMoreLinkHandler(linkUrl)}
                    componentClasses={styles.linkText}
                >
                    {linkText}
                </Link>
            </>
        );
    }

    return (
        <Text textColor="primary-700" skin="paragraph-1" fontWeight="normal">
            {content}
        </Text>
    );
};

export const DialogContent = (props: DialogContentProps) => {
    const {
        content,
        title,
        additionalContent,
        linkText,
        linkUrl,
        lottieContent,
        showMoreLinkHandler
    } = props;
    const [isImageLoaded, setIsImageLoaded] = useState(false);

    useEffect(() => {
        return setIsImageLoaded(false);
    }, [additionalContent]);

    const lottieData = {
        loop: true,
        autoplay: true,
        animationData: lottieContent
    };

    return (
        <Flex direction="column" justifyContent="space-between" alignItems="center">
            {!!additionalContent && (
                <img
                    style={isImageLoaded ? {} : {width: 640, height: 360}}
                    className={styles.additionalContent}
                    src={additionalContent}
                    alt="Priority announcements image"
                    draggable={false}
                    onLoad={() => {
                        setIsImageLoaded(true);
                    }}
                />
            )}
            {!!lottieContent && (
                <Lottie
                    options={lottieData}
                    height={360}
                    width={640}
                    className={styles.additionalContent}
                    style={{marginBottom: '24px'}}
                />
            )}
            <Scrollbar
                rtl={isRTL()}
                autoHeight={true}
                autoHeightMax={175}
                componentClasses={styles.dialogContent}
            >
                <Title
                    componentClasses={styles.dialogContentTitle}
                    skin="h2"
                    textColor="primary-700"
                >
                    {title}
                </Title>
                <ContentComp
                    content={content}
                    linkText={linkText}
                    linkUrl={linkUrl}
                    showMoreLinkHandler={showMoreLinkHandler}
                />
            </Scrollbar>
        </Flex>
    );
};
